import { store } from '../index';
import { setGlobalOrg, setGlobalOrgId } from '../redux/actions/building';

// TODO: Get rid of setGlobalOrgId and just stick to setGlobalOrg instead.
// It will stay here for now just in case something depends on it.
export const setGlobalOrganization = (organization) => {
  store.dispatch(setGlobalOrgId(organization.id));
  store.dispatch(setGlobalOrg(organization));
};
